import PropTypes from 'prop-types';
import React from 'react';

import Filter, { FilterModal, FilterSection } from '../../SearchPage/Filters/Filter';
import UtrFitFilter from '../../SearchPage/Filters/FilterComponents/UtrFitFilter';
import styles from '../../SearchPage/search.scss';

const filterName = 'utrFit';

const CollegeFitToolFilter = (props) => {
    const {
        type,
        filters,
        filterInputs,
        handleFilterClick,
        filterModal,
        closeModals,
        handleFilterSubmit,
        handleFilterUpdate,
        mobileOnly,
        desktopOnly,
        'data-testid': dataTestId,
    } = props;

    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={filterName}
                searchFor={type}
                handleFilterClick={handleFilterClick}
                isActive={filters.utrFitRating || filterModal === filterName}
                onClick={() => handleFilterClick(filterName)}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >
                College Fit Tool
            </Filter>
            {filterModal === filterName && (
                <FilterModal
                    title={'College Fit Tool'}
                    handleFilterSubmit={handleFilterSubmit}
                    onCloseClick={closeModals}
                    data-testid={dataTestId}
                >
                    <FilterSection>
                        <UtrFitFilter
                            filterInputs={filterInputs}
                            handleUtrFitRatingChange={(e) => {
                                handleFilterUpdate({ utrFitRating: e.target.value });
                            }}
                            handleUtrFitPositionChange={(utrFitPosition) => {
                                handleFilterUpdate({ utrFitPosition });
                            }}
                            data-testid={dataTestId && `${dataTestId}.utr-fit`}
                        />
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

CollegeFitToolFilter.propTypes = {
    type: PropTypes.string,
    filters: PropTypes.instanceOf(Object).isRequired,
    filterInputs: PropTypes.instanceOf(Object).isRequired,
    filterModal: PropTypes.string.isRequired,
    handleFilterClick: PropTypes.func,
    closeModals: PropTypes.func,
    handleFilterSubmit: PropTypes.func,
    handleFilterUpdate: PropTypes.func,
    mobileOnly: PropTypes.bool,
    desktopOnly: PropTypes.bool,
    'data-testid': PropTypes.string,
};

CollegeFitToolFilter.defaultProps = {
    type: '',
    handleFilterClick: () => { },
    closeModals: () => { },
    handleFilterSubmit: () => { },
    handleFilterUpdate: () => { },
    mobileOnly: false,
    desktopOnly: false,
    'data-testid': null,
};

export default CollegeFitToolFilter;
